import { render, staticRenderFns } from "./RecordAudioPronunciation.vue?vue&type=template&id=da8ca4e8"
import script from "./RecordAudioPronunciation.vue?vue&type=script&lang=js"
export * from "./RecordAudioPronunciation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports